import { useQuery } from 'react-query';
import request from '../../../../../../helpers/request';
import { baseQueryOptions } from '../../config/queries';

const url = 'HousingStock/available_import';
const errorPlaceholder = 'Error';

const fetchAvailableImport = (companyId) =>
  request.get(
    url,
    { companyId },
    undefined,
    errorPlaceholder,
    undefined,
    undefined,
    {},
    true
  );

const select = (data) =>
  data === errorPlaceholder ? data : Boolean(data?.availableImport);

export const useAvailableImport = (companyId) =>
  useQuery([url, companyId], () => fetchAvailableImport(companyId), {
    ...baseQueryOptions,
    enabled: Boolean(companyId),
    staleTime: Infinity,
    select,
  });

export const availableImportErrorPlaceholder = errorPlaceholder;
